/** @format */

import React from 'react'

import { Row, Col, Popover } from 'antd'

import './style.css'

export default function UserInfoOrders(props) {
	return (
		<div className='ph-quotation-detail-user-info-container'>
			<h1 className='ph-quotation-detail-user-info-title'>Informacion del Usuario</h1>
			<Row className='ph-quotation-detail-user-personal-date-container'>
				<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
					<strong className='ph-quotation-detail-user-info-title-user'>Nombre (s):</strong>
				</Col>
				<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
					<strong className='ph-quotation-detail-user-info-title-user'>Apellidos (s):</strong>
				</Col>
				<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
					<strong className='ph-quotation-detail-user-info-title-user'>Identificación:</strong>
				</Col>
				<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
					<strong className='ph-quotation-detail-user-info-title-user'>Género:</strong>
				</Col>
				<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
					<strong className='ph-quotation-detail-user-info-title-user'>Correo:</strong>
				</Col>
				<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
					<strong className='ph-quotation-detail-user-info-title-user'>Teléfono:</strong>
				</Col>
			</Row>
			<div className='ph-quotation-detail-user-info-main-container'>
				<Row>
					<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
						<span className='ph-quotation-detail-user-info-personal-date'>{props.userInfo.first_name}</span>
					</Col>
					<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
						<span className='ph-quotation-detail-user-info-personal-date'>{props.userInfo.last_name}</span>
					</Col>
					<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
						<span className='ph-quotation-detail-user-info-personal-date'>{props.userInfo.rut}</span>
					</Col>
					<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
						<span className='ph-quotation-detail-user-info-personal-date'>{props.userInfo.sex}</span>
					</Col>
					<Col lg={4} className='ph-quotation-detail-user-info-personal-date-container'>
						<Popover content={props.userInfo.email}>
							<p className='ph-quotation-detail-user-info-personal-date ph-quotation-email'>
								{props.userInfo.email}
							</p>
						</Popover>
					</Col>
					<Col lg={4} className='ph-quotation-detail-user-info-personal-date-phone'>
						<span className='ph-quotation-detail-user-info-personal-date'>{props.userInfo.phone}</span>
					</Col>
				</Row>
				<Row className='ph-quotation-detail-user-info-location-date-container'>
					<Col lg={12}>
						<strong className='ph-quotation-detail-user-info-title-user'>Dirección:</strong>
						<span className='ph-quotation-detail-user-info-personal-date'>
							{props.userInfo.location.address}
						</span>
					</Col>
				</Row>
			</div>
		</div>
	)
}
